var map = {
	"./role-1/3.png": "xBTJ",
	"./role-2/3.png": "jqQd",
	"./role-3/3.png": "PnRr",
	"./role-4/3.png": "WqaP"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Zumy";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4 ^\.\/role\-.*\/3\.png$
// module id = Zumy
// module chunks = 0